import _objectWithoutProperties from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import Prefetcher from './prefetcher';
export default Prefetcher;
export var OnRenderPrefetcher = function OnRenderPrefetcher(_ref) {
  var link = _ref.link,
      other = _objectWithoutProperties(_ref, ["link"]);

  return React.createElement(Prefetcher, _extends({
    onRenderAssets: link
  }, other));
};
export var OnHoverPrefetcher = function OnHoverPrefetcher(_ref2) {
  var link = _ref2.link,
      other = _objectWithoutProperties(_ref2, ["link"]);

  return React.createElement(Prefetcher, _extends({
    onHoverAssets: link
  }, other));
};
export var OnClickPrefetcher = function OnClickPrefetcher(_ref3) {
  var link = _ref3.link,
      other = _objectWithoutProperties(_ref3, ["link"]);

  return React.createElement(Prefetcher, _extends({
    onClickAssets: link
  }, other));
};